import { useEffect, useState } from 'react'

const TOTAL_SECONDS = 23 * 3600 + 59 * 60 + 43

export type Countdown = {
  hours: string
  minutes: string
  seconds: string
}

const pad = (n: number): string => String(n).padStart(2, '0')

export function useCountdown(): Countdown {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? TOTAL_SECONDS : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
